import http from "../../../api/http";

export const exportDatabase = tenantIds => {
  return http.post("Database/Export/", tenantIds);
};
